/**
 * API base URL configuration.
 *
 * - In the browser dev server (npm start), the CRA proxy handles /api → backend,
 *   so API_BASE is empty (relative fetches work).
 * - In a Capacitor native build, there is no dev-server proxy, so we must point
 *   to the real backend URL.  Set REACT_APP_API_URL at build time:
 *
 *       REACT_APP_API_URL=https://your-server.example.com npm run build
 *
 *   or drop the value into frontend/.env.production:
 *       REACT_APP_API_URL=https://your-server.example.com
 */

// Use 10.0.2.2 for Android emulator to access host machine backend
// Use LAN IP for Android emulator/device to access host machine backend

let API_BASE = process.env.REACT_APP_API_URL;

if (!API_BASE) {
	if (process.env.NODE_ENV === 'production') {
		// In a Capacitor native build window.location.origin is 'capacitor://localhost'
		// (iOS) or 'http://localhost' (Android) — neither is the API server.
		// For web builds, use relative paths (same origin as the SPA).
		// For Capacitor, set REACT_APP_API_URL at build time via .env.production.
		API_BASE = '';
	} else {
		// Local development: empty string → relative paths → CRA proxy forwards to Flask.
		API_BASE = '';
	}
}

// Ensure the exported API_BASE does not end with a trailing slash to keep fetch paths consistent.
if (API_BASE.endsWith('/')) {
	API_BASE = API_BASE.replace(/\/+$/, '');
}

export default API_BASE;
